import { NFTs } from './NFTs'

export default NFTs
